import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { clamp } from '../../util';

export interface PageChangeEvent {
  startIndex: number;
  endIndex: number;
}

@Component({
  selector: 'cp-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginatorComponent implements OnInit, OnChanges {
  @Input()
  itemCount: number;

  @Input()
  itemsPerPage = 15;

  @Output()
  pageChange = new EventEmitter<PageChangeEvent>();

  currentPage = 0;
  pages: number[];

  constructor(private cd: ChangeDetectorRef) {
  }

  onPageChange(page: number) {
    this.currentPage = page;

    const startIndex = this.currentPage * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.pageChange.emit({ startIndex, endIndex });
  }

  canStep(delta: number) {
    const newPage = this.currentPage + delta;
    return newPage >= 0 && newPage < this.pages.length;
  }

  onStepPage(delta: number) {
    this.onPageChange(clamp(this.currentPage + delta, 0, this.pages.length - 1));
  }

  ngOnInit() {
    this.updatePages(this.itemCount, this.itemsPerPage);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const itemCount = changes['itemCount'];
    if (itemCount) {
      this.updatePages(itemCount.currentValue || this.itemCount, this.itemsPerPage);
    }
  }

  updatePages(itemCount: number, itemsPerPage: number) {
    this.pages = Array(Math.ceil(this.itemCount / this.itemsPerPage)).fill(0).map((_, i) => i);
    this.cd.detectChanges();
  }
}
